import { EVENT_CART_UPDATE } from "@app/components/cart"
import { getProduct } from "@app/lib/product";
import { Cart } from "@app/types/cart";
import { Product } from "@app/types/product";
import React from "react";
import ReactDOM from "react-dom/client";
import { CartItems } from "@app/components/CartItems";
import { addDiscountCode } from "@app/lib/cart";

class CartFull extends HTMLElement {
  $discountCodeInputWrapper: HTMLDivElement | null = null;
  $cartItems: HTMLDivElement | null = null;

  constructor() {
    super();
    this.$discountCodeInputWrapper = this.querySelector(".discount-code-input-wrapper");
    this.$cartItems = this.querySelector(".cart-items");
  }

  connectedCallback() {
    document.addEventListener(EVENT_CART_UPDATE, async (e: any) => {
      if (e.detail?.cart) {
        const products = await this.fetchProducts(e.detail.cart);
        // this.prepareMiniCart(e.detail.cart);
        this.renderItems(e.detail.cart, products);
      }
    });

    this.initDiscountCodes();
  }

  initDiscountCodes() {
    if (!this.$discountCodeInputWrapper) return;

    const $input = this.$discountCodeInputWrapper.querySelector("input")!;
    const $button = this.$discountCodeInputWrapper.querySelector("button")!;

    $input.addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        if ($input.value.trim()) $button.click();
      }
    });

    $button.addEventListener("click", async () => {
      const value = $input.value.trim();
      if (value) {
        $button.disabled = true;
        await addDiscountCode(value);
        window.location.reload();
      }
    });
  }

  async fetchProducts(cart: Cart) {
    let handles = cart.items.map((item) => item.handle);
    handles = [...new Set(handles)];
    const products = await Promise.all(handles.map((handle) => getProduct(handle)));
    return products;
  }

  renderItems(cart: Cart, products: Product[]) {
    if (this.$cartItems) {
      this.$cartItems.innerHTML = "";
    } else {
      return;
    }

    const root = ReactDOM.createRoot(this.$cartItems);
    root.render(<CartItems cart={cart} products={products} zCodeDisclaimer={this.dataset?.zCartDisclaimer} />);
  }
}

customElements.define("cart-full", CartFull);
